import { create } from "zustand";

export const useEmailSenderStore = create((set) => ({
  customDomain: null,
  setCustomDomain: (domain) => set({ customDomain: domain }),

  emailSenderList: [],
  setEmailSenderList: (list) => set({ emailSenderList: list }),

  defaultConfigEmail: {
    name: "",
    email: "",
  },
  setDefaultConfigEmail: (config) => set({ defaultConfigEmail: config }),

  defaultConfigNumber: {
    name: "",
    number: "",
  },
  setDefaultConfigNumber: (config) => set({ defaultConfigNumber: config }),
}));
